require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-interviste-raffaele-cavadini.json") })
        }
      }, "path---en-interviste-raffaele-cavadini");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-interviste-raffaele-cavadini!./.cache/json/en-interviste-raffaele-cavadini.json
// module id = 597
// module chunks = 231608221292675